<template>
  <div 
    :class="{ active: isActive }" 
    class="loader-container" >
    <span class="processing" />
  </div>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      return this.show;
    }
  }
}
</script>

<style lang="css">
  .loader-container {
      display: none;
      position: fixed;
      z-index: 999;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 2em;
      width: 2em;
  }

  .loader-container.active {
      display: inline;
  }

  .processing {
    display: inline-block;
    height: 200px;
    width: 200px;
    background-repeat: no-repeat; 
    background-image: url('../../assets/img/loader-orange.gif');
  }
</style>
